import type Policy from 'modules/core/store/models/policies/Policy'

import { Model } from './mobx-rest'
import { VerbTypes } from './verbTypes'

export class ModelWithPolicy<
  Attributes extends Record<string, any> = any
> extends Model<Attributes> {
  get policy(): Policy<VerbTypes> {
    throw new Error(`Undefined policy for model ${this.constructor}`)
  }
}
